"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'DARegionAop',
      searchQuery: {
        brand: '',
        year: null
      },
      optConfig: {
        prodBrandOptions: [] // 自身品牌select
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        pcd: {
          label: this.$t('sfe.DARegionAop.region'),
          inputType: 'pcd',
          regionProps: {
            expandTrigger: 'hover',
            checkStrictly: true
          },
          returnArray: true,
          level: 1,
          keyList: ['region', 'regionCodeList']
        },
        brand: {
          label: this.$t('common.brand'),
          valueKey: 'brand',
          inputType: 'select',
          options: this.optConfig.prodBrandOptions,
          optionLabel: 'name',
          optionValue: 'code'
        },
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.daregionaop'),
          apiUrl: '/protected/regionAopKpi/export'
        },
        import: {
          apiUrl: '/protected/regionAopKpi/import'
        }
      };
    },
    tableDom: function tableDom() {
      var month12List = this.createMonth12List();
      return (0, _objectSpread2.default)({
        region: {
          label: this.$t('sfe.DARegionAop.region')
        },
        brand: {
          label: this.$t('common.brand')
        },
        year: {
          label: this.$t('common.year2')
        }
      }, month12List);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/regionAopKpi/list'
      };
    }
  },
  mounted: function mounted() {
    // 获取下拉选项
    this.queryEnumOptions();
  },
  methods: {
    createMonth12List: function createMonth12List() {
      var _this = this;
      var month12 = new Array(12).toString().split(',').map(function (t, i) {
        return i + 1;
      });
      var keyPre = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
      var month12List = {};
      month12.forEach(function (m) {
        month12List["".concat(keyPre[m - 1], "SalesTargetQty")] = {
          label: _this.$t("sfe.DARegionAop.".concat(keyPre[m - 1], "SalesTargetQty")),
          isCommasNumber: true
        };
      });
      return month12List;
    },
    queryEnumOptions: function queryEnumOptions() {
      var _this2 = this;
      var prodBrand_key = 'PRODUCT_BRAND'; // 自身品牌
      var param = {
        configItemCodeList: [prodBrand_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        // console.log(999, res)
        _this2.optConfig.prodBrandOptions = data[prodBrand_key] || [];
        console.log(999, _this2.optConfig.prodBrandOptions);
      });
    }
  }
};